import { render } from "./ContractorCompanyPeople.vue?vue&type=template&id=4c77ab60&scoped=true&ts=true"
import script from "./ContractorCompanyPeople.vue?vue&type=script&lang=ts"
export * from "./ContractorCompanyPeople.vue?vue&type=script&lang=ts"

import "./ContractorCompanyPeople.vue?vue&type=style&index=0&id=4c77ab60&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c77ab60"]])

export default __exports__